import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { ListItemSecondary } from 'src/domains/layouts/shared/cms/list/listItems/ListItemSecondary';
import { SeoFormState, SeoPageType } from 'src/main/cms/SeoManagement/SeoForm/SeoFormState';
import { SeoItemState } from 'src/main/cms/SeoManagement/SeoItemState';

interface PromoCarouselPropsType {
    seoPageType: SeoPageType;
    seoFormState: SeoFormState;
}

export const SeoListItem = observer((props: PromoCarouselPropsType) => {
    const { trpcClient } = useAppStateContext();
    const { seoPageType, seoFormState } = props;

    const [itemState] = React.useState(() => new SeoItemState(seoPageType, seoFormState, trpcClient));

    const {
        handleDeleteSeoPage,
        handleEdit,
        handleDuplicate,
        showDeletePopup,
        handleShowDeletePopup,
        handleHideDeletePopup,
        setActive,
        isEdited,
        isActive,
    } = itemState;

    return (
        <ListItemSecondary
            label={seoPageType.title ?? ''}
            setPublished={setActive}
            isEdited={isEdited}
            isPublished={isActive}
            handleDelete={handleDeleteSeoPage}
            handleEdit={handleEdit}
            handleDuplicate={handleDuplicate}
            handleShowDeletePopup={handleShowDeletePopup}
            handleHideDeletePopup={handleHideDeletePopup}
            showDeletePopup={showDeletePopup}
            dataTest='seo-pages-list-item'
        />
    );
});
